import React from 'react';
import { BaseButton, useT } from '@repo/common';

function LinkList({ onSelect }) {
  const t = useT();
  const options = [
    { label: 'Link', labelKr: '링크' },
    { label: 'Portfolio', labelKr: '포트폴리오' },
    { label: 'Personal Website', labelKr: '개인 웹사이트' },
    { label: 'LinkedIn', labelKr: 'LinkedIn' },
    { label: 'GitHub', labelKr: 'GitHub' },
    { label: 'Behance', labelKr: 'Behance' },
    { label: 'Dribbble', labelKr: 'Dribbble' },
    { label: 'Notion', labelKr: 'Notion' },
    { label: 'Blog', labelKr: '블로그' },
    { label: 'Instagram', labelKr: 'Instagram' },
    { label: 'TikTok', labelKr: 'TikTok' },
    { label: 'Threads', labelKr: 'Threads' },
    { label: 'X (Twitter)', labelKr: 'X (Twitter)' },
    { label: 'YouTube', labelKr: 'YouTube' },
  ];

  return (
    <div
      className='w-full min-w-[200px] max-h-[282px] overflow-y-auto bg-grayscale-gray00 border border-grayscale-gray02
                rounded-[15px] p-2 shadow-popup-02'
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => (
          <li
            key={option.label}
            className='flex items-center rounded-lg transition-colors duration-150'
          >
            <BaseButton
              type='text'
              size='m'
              hideIcon
              bgclass='bg-grayscale-gray00'
              borderclass='border-none'
              textclass='justify-start'
              hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
              activeclass='active:bg-grayscale-gray02 active:text-text-primary'
              width='100%'
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSelect(option.label);
              }}
              leftalign='true'
            >
              {t(option.label, option.labelKr)}
            </BaseButton>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LinkList;
